import React from 'react';
import { Navigate } from 'react-router-dom';

// Layouts
import {
  AppLayout,
  AuthLayout,
  MainLayout,
  ContentLayout,
  PublicLayout,
  RecommendationLayout,
  ExamLayout,
  LiveLayout,
  SurveyLayout,
  EducationalLayout,
} from 'layouts';

import { NotFoundView } from 'features/errors/views';
import {
  LoginView,
  LogoutView,
  RegisterView,
  RegisterSuccessView,
  ForgotPasswordView,
  ResetPasswordView,
  FinishRegisterView,
  ResetView,
  TokenView,
} from 'features/auth/views';
import { ProductsListView, ProductsDetailsView, MyProductsListView, ProductsEvolutionView } from 'features/products/views';
import { BooksListView, BooksDetailsView } from 'features/books/views';
import { TeachersListView, TeacherDetailsView } from 'features/teachers/views';

import Dashboard from 'features/dashboard';
import { ContentScormView, ContentsDetailsView } from 'features/contents/views';
import { ModulesDetailsView } from 'features/modules';
import { AccountView, CertificatesView, ChangePasswordView, ClassdiaryView, DocumentsView, MessagesView } from 'features/account';
// import { MyBadgesListView } from 'features/badges';
import { LpMentoria, LpOpcoes, LpAncord, LpFraternidade } from 'features/lps';
import HP, { OpenHP } from 'features/hp';
import { PaymentsCheckoutView as OffersCheckoutView, PaymentsSuccessView as OffersSuccessView } from 'features/offers';
// import { RedirectToNewView } from 'features/payments';
import { ReportsListView } from 'features/reports';
import { ForgotPasswordAppView, RegisterAppView } from 'features/auth/views/app';
import { RecommendationsDetailsView } from 'features/recommendations';
import { ExamsAssessmentMainView, ExamsAssessmentQuestionView, ExamsAssessmentResultView, ExamsDetailsView, ExamsListView } from 'features/exams';
import IncarnateView from 'features/auth/views/incarnateView';
import OffersLayout from 'layouts/offersLayout';
import { ProgramsDetailsView } from 'features/programs';
import { DashboardView, DashboardSearchView, DashboardCurrentView } from 'features/dashboard-new';
import { MasterclassDetailsView } from 'features/masterclass';
import { JourneyAreaDetailsView, JourneyLivesView, JourneysDetailsView } from 'features/journeys';
import { ActivationForm, MfaSupportView } from 'features/mfa';
import { LiveConfirmationPage } from 'features/lives';
import { EventsDetailsView } from 'features/events';
import { SearchResultsPage } from 'features/search';
import { SurveysList, SurveyView } from 'features/surveys';
import {
  EducationalMainPage,
  EducationalRecoveryUserPage,
  EducationalRegisterPage,
  EducationalRegisterSuccessPage,
  EducationalResetPasswordPage,
  EducationalSwitcherPage,
} from 'features/educational';

// import ClearCookies from 'features/school/ClearCookies';
// import Termo from 'components/termo/Termo';

const routes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [{ path: '/', element: <Dashboard />, exact: true }],
  },

  {
    path: '/dashboard',
    element: <MainLayout />,
    children: [
      { path: '/', element: <DashboardView /> },
      {
        path: '/:dashboardUuid',
        children: [
          {
            path: '/',
            element: <DashboardCurrentView />,
          },
          {
            path: '/area/:dashboardAreaUuid',
            element: <DashboardSearchView />,
          },
        ],
      },
    ],
  },

  {
    path: '/search',
    element: <MainLayout withoutSearchButton />,
    children: [{ path: '/', element: <SearchResultsPage /> }],
  },

  {
    path: '/',
    element: <AuthLayout />,
    children: [
      { path: 'auth', element: <TokenView /> },
      { path: 'register', element: <RegisterView /> },
      { path: 'register/success', element: <RegisterSuccessView /> },
      { path: 'login', element: <LoginView /> },
      { path: 'logout', element: <LogoutView /> },
      { path: 'reset', element: <ResetView /> },
      { path: 'forgot-password', element: <ForgotPasswordView /> },
      { path: 'reset-password/:recoveryToken', element: <ResetPasswordView /> },
      { path: 'finish-register-user/:recoveryTokenUuid', element: <FinishRegisterView /> },
      { path: 'login/activation', element: <ActivationForm type="login" action="activation" /> },
      { path: 'login/authentication', element: <ActivationForm type="login" action="login" /> },
      {
        path: 'login/authentication/support',
        element: <MfaSupportView />,
      },
      {
        path: 'login/activation/support',
        element: <MfaSupportView />,
      },
    ],
  },

  {
    path: '/app/',
    element: <AppLayout />,
    children: [
      { path: 'forgot-password', element: <ForgotPasswordAppView /> },
      { path: 'register', element: <RegisterAppView /> },
      // { path: 'register/success', element: <RegisterSuccessView /> },
    ],
  },

  {
    path: '/lp',
    element: <PublicLayout />,
    children: [
      { path: 'mentoria', element: <LpMentoria /> },
      { path: 'mentoria/:affiliateId', element: <LpMentoria /> },
      { path: 'opcoes', element: <LpOpcoes /> },
      { path: 'ancord', element: <LpAncord /> },
      { path: 'fraternidade-melver', element: <LpFraternidade /> },
    ],
  },

  {
    path: '/hp',
    element: <PublicLayout />,
    children: [
      { path: '/', element: <HP /> },
      { path: 'open', element: <OpenHP /> },
    ],
  },

  {
    path: '/products/:productSlug/modules/:moduleUuid/contents/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView /> }],
  },
  {
    path: '/products/:productSlug/contents/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView /> }],
  },

  {
    path: '/products/:productSlug/classes/:productClassUuid/modules/:moduleUuid/contents/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView /> }],
  },
  {
    path: '/products/:productSlug/classes/:productClassUuid/contents/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView /> }],
  },
  {
    path: '/products/:productSlug/classes/:productClassUuid/lives/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView isLive /> }],
  },
  {
    path: '/products/:productSlug/classes/:productClassUuid/scorm',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentScormView /> }],
  },
  {
    path: '/products/:productSlug/classes/:productClassUuid/recommendations/:recommendationUuid',
    element: <RecommendationLayout />,
    children: [{ path: '/', element: <RecommendationsDetailsView /> }],
  },
  {
    path: '/products',
    element: <MainLayout />,
    children: [
      { path: '/', element: <ProductsListView /> },
      { path: '/:productSlug', element: <ProductsDetailsView /> },
      { path: '/:productSlug/classes/:productClassUuid', element: <ProductsDetailsView /> },
      { path: '/:productSlug/evolution', element: <ProductsEvolutionView /> },
      {
        path: '/:productSlug/classes/:productClassUuid/evolution',
        element: <ProductsEvolutionView />,
      },
      {
        path: '/:productSlug/modules/:moduleUuid',
        element: <ModulesDetailsView />,
      },
      {
        path: '/:productSlug/classes/:productClassUuid/modules/:moduleUuid',
        element: <ModulesDetailsView />,
      },

      {
        path: '/:productSlug/enroll',
        element: <ProductsDetailsView enroll />,
      },
      {
        path: '/:productSlug/classes/:productClassUuid/enroll',
        element: <ProductsDetailsView enroll />,
      },
    ],
  },

  {
    path: '/lives/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView isLive noProduct /> }],
  },

  {
    path: '/lives/:productSlug/:contentUuid/:contentTypeSlug',
    element: <ContentLayout />,
    children: [{ path: '/', element: <ContentsDetailsView isLive noProduct /> }],
  },

  {
    path: '/lives/:liveUuid/attendanceconfirmation',
    element: <LiveLayout />,
    children: [{ path: '/', element: <LiveConfirmationPage /> }],
  },

  {
    path: '/reports',
    element: <MainLayout />,
    children: [
      { path: '/', element: <Navigate to="./list" replace /> },
      { path: 'list', element: <ReportsListView /> },
      { path: ':reportCategoryUuid/list', element: <ReportsListView /> },
    ],
  },

  //   {
  //     path: '/products/:productSlug/classes/:productClassUuid/checkout',
  //     element: <RedirectToNewView />,
  //     // children: [
  //     //   { path: '/', element: <RedirectToNewView /> },
  //     //   { path: '/success', element: <PaymentsSuccessView /> },
  //     // ],
  //   },

  {
    path: '/:offerIdentifier/checkout',
    element: <OffersLayout />,
    children: [
      { path: '/', element: <OffersCheckoutView /> },
      { path: '/success', element: <OffersSuccessView /> },
    ],
  },

  {
    path: '/books',
    element: <MainLayout />,
    children: [
      { path: '/', element: <BooksListView /> },
      { path: '/:bookSlug', element: <BooksDetailsView /> },
    ],
  },

  {
    path: '/exams',
    element: <MainLayout />,
    children: [{ path: '/', element: <ExamsListView /> }],
  },

  {
    path: '/exams/:examUuid',
    element: <ExamLayout />,
    children: [
      { path: '/', element: <ExamsDetailsView /> },
      {
        path: '/assessment/:assessmentUuid',
        element: <ExamsAssessmentMainView />,
        children: [
          { path: '/question/:questionUuid', element: <ExamsAssessmentQuestionView /> },
          { path: '/result', element: <ExamsAssessmentResultView /> },
        ],
      },
    ],
  },

  {
    path: '/teachers',
    element: <MainLayout />,
    children: [
      { path: '/', element: <TeachersListView /> },
      { path: '/:teacherSlug', element: <TeacherDetailsView /> },
    ],
  },

  {
    path: '/programs',
    element: <MainLayout />,
    children: [
      { path: '/:productSlug', element: <ProgramsDetailsView /> },
      { path: '/:productSlug/enroll', element: <ProgramsDetailsView enroll /> },
    ],
  },

  {
    path: '/masterclass',
    element: <MainLayout />,
    children: [
      {
        path: '/:productSlug',
        children: [
          {
            path: '/',
            element: <MasterclassDetailsView />,
          },

          {
            path: '/classes/:productClassUuid',
            element: <MasterclassDetailsView />,
          },

          {
            path: '/enroll',
            element: <MasterclassDetailsView enroll />,
          },

          {
            path: '/classes/:productClassUuid/enroll',
            element: <MasterclassDetailsView enroll />,
          },
        ],
      },
    ],
  },

  {
    path: '/journeys',
    element: <MainLayout />,
    children: [
      {
        path: '/:productSlug',
        children: [
          {
            path: '/',
            element: <JourneysDetailsView />,
          },

          {
            path: '/areas/:journeyAreaUuid',
            element: <JourneyAreaDetailsView />,
          },

          {
            path: '/lives',
            element: <JourneyLivesView />,
          },

          {
            path: '/enroll',
            element: <JourneysDetailsView enroll />,
          },
        ],
      },
    ],
  },

  {
    path: '/surveys',
    element: <SurveyLayout />,
    children: [
      { path: '/', element: <SurveysList /> },
      {
        path: '/:surveyUuid',
        children: [
          {
            path: '/',
            element: <SurveyView />,
          },
        ],
      },
    ],
  },

  {
    path: '/account',
    element: <MainLayout />,
    children: [
      { path: '/', element: <AccountView /> },
      { path: '/courses', element: <MyProductsListView /> },
      { path: '/certificates', element: <CertificatesView /> },
      { path: '/messages', element: <MessagesView /> },
      { path: '/documents', element: <DocumentsView /> },
      { path: '/classdiary', element: <ClassdiaryView /> },
      // { path: '/badges', element: <MyBadgesListView /> },
      { path: '/change-password', element: <ChangePasswordView /> },
    ],
  },

  {
    path: '/confirm-current-email-for-change',
    element: <MainLayout />,
    children: [{ path: ':recoveryToken', element: <AccountView confirmCurrentEmail /> }],
  },

  {
    path: '/confirm-new-email-for-change',
    element: <MainLayout />,
    children: [{ path: ':recoveryToken', element: <AccountView confirmNewEmail /> }],
  },

  // {
  //   path: '/clear',
  //   element: <ClearCookies />,
  // },

  {
    path: '/health',
    element: <>ok</>,
  },

  {
    path: '/incarnate',
    element: <IncarnateView />,
  },

  //MFA

  {
    path: '/mfa',
    element: <MainLayout />,
    children: [
      {
        path: '/activation',
        element: <ActivationForm action="activation" />,
      },
      {
        path: '/disable',
        element: <ActivationForm action="disable" />,
      },
      {
        path: '/support',
        element: <MfaSupportView />,
      },
    ],
  },

  {
    path: '/events',
    element: <MainLayout />,
    children: [
      { path: '/', element: <ProductsListView /> },
      { path: '/:productSlug/:productClassUuid/:contentUuid', element: <EventsDetailsView /> },
    ],
  },
  {
    path: '/educacional',
    element: <EducationalLayout />,
    children: [
      { path: '/', element: <EducationalMainPage /> },
      { path: '/selecao', element: <EducationalSwitcherPage /> },
      {
        path: '/cadastro',
        children: [
          { path: '/', element: <EducationalRegisterPage /> },
          { path: '/sucesso', element: <EducationalRegisterSuccessPage /> },
        ],
      },
      { path: '/alterar-senha', element: <EducationalResetPasswordPage /> },
      { path: '/recuperar-usuario', element: <EducationalRecoveryUserPage /> },
    ],
  },

  {
    path: '*',
    element: <NotFoundView />,
  },
];

export default routes;
